var exports = {
  "iE": "x234b8571--b50ea7--wrapper",
  "vW": "x234b8571--b50ea7--inner",
  "d": "x234b8571--b50ea7--inner--short",
};

module.exports = exports;
